export class NativeStreamHttpConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "headers",
            "baseName": "headers",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "apiKeyHeader",
            "baseName": "apiKeyHeader",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiKeyPrefix",
            "baseName": "apiKeyPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamHttpConnection.attributeTypeMap;
    }
    constructor() {
    }
}
